import axios from "axios";
import {authHeader} from "_helpers";
import {SERVER_URL} from "../config";

function fetchMacro(params) {
    const endpoint = `${SERVER_URL}/api/v1/platformMacros`;
    return axios.get(endpoint,{
        params: params,
        headers: authHeader()
    })
}

export const macroService = {
    fetchMacro
}